<template>
  <div class="ship-rules-wrap">
    <div class="page-header">
      <div class="flex-row-between-center title-top">
        <div class="flex-row-start-center">
          <div class="title-left">
            当前店铺发货规则：
          </div>
          <div class="m-l-40">
            <span class="el-icon-warning c-red"></span>
            请注意：商家提交申请后，需平台审核通过才生效。平台审核时效：
            <span class="c-red">1个工作日</span>
          </div>
        </div>
        <div class="apply-btn" @click="showDialog">编辑</div>
      </div>
      <div class="top-info">
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="6"
            ><div class="grid-content bg-purple">
              店铺接单时间:&nbsp;{{ detail.start_time }}
            </div></el-col
          >
          <el-col :span="6"
            ><div class="grid-content bg-purple-light">
              店铺截单时间:&nbsp;{{ detail.end_time }}
            </div></el-col
          >
          <el-col :span="6"
            ><div class="grid-content bg-purple">
              周末发货规则:&nbsp;{{ detail.week_end_rule_str }}
            </div></el-col
          >
        </el-row>
      </div>
    </div>
    <div class="gray-bg"></div>

    <div style="padding-top: 8px;">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%; text-align: center"
        size="mini"
      >
        <el-table-column prop="id" label="申请单号" width="100" />
        <el-table-column prop="title" label="变更前">
          <template slot-scope="scope">
            <div class="text-left">
              店铺接单时间：{{ scope.row.before_start_time }}
            </div>
            <div class="text-left">
              店铺截单时间：{{ scope.row.before_end_time }}
            </div>
            <div class="text-left">
              周末发货规则：{{ scope.row.before_shipping_rule_str }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="变更后">
          <template slot-scope="scope">
            <div class="text-left">
              店铺接单时间：{{ scope.row.after_start_time }}
            </div>
            <div class="text-left">
              店铺截单时间：{{ scope.row.after_end_time }}
            </div>
            <div class="text-left">
              周末发货规则：{{ scope.row.after_shipping_rule_str }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="发起时间" width="180" />
        <el-table-column prop="review_time" label="审核时间" width="180" />
        <el-table-column prop="applicant_name" label="申请人" />
        <el-table-column prop="status_str" label="状态" />
        <el-table-column prop="review_comment" label="审批备注" />
      </el-table>
    </div>
    <el-pagination
      style="text-align: center"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="queryInfo.current"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="queryInfo.page_size"
      layout="total,sizes, prev, pager, next,jumper"
      :total="queryInfo.total"
    >
    </el-pagination>
    <!-- 编辑弹框 -->
    <el-dialog
      custom-class="ship-rule-dialog"
      title="编辑规则"
      append-to-body
      center
      :visible.sync="visible"
      width="660px"
      @close="hideDialog"
      :destroy-on-close="true"
    >
      <el-form
        :model="addForm"
        :rules="rules"
        ref="addForm"
        label-width="100px"
        class="rule-edit-form"
      >
        <el-form-item prop="start_time" label="店铺接单时间">
          <el-time-picker
            v-model="addForm.start_time"
            :format="'HH:mm'"
            placeholder="接单时间"
          >
          </el-time-picker>
        </el-form-item>

        <el-form-item prop="end_time" label="店铺截单时间">
          <el-time-picker
            v-model="addForm.end_time"
            :format="'HH:mm'"
            placeholder="截单时间"
          >
          </el-time-picker>
        </el-form-item>

        <el-form-item label="周末发货规则" prop="week_rule">
          <!-- 2=周末发货，意思：周六、周日全发 -->
          <el-checkbox-group v-model="addForm.week_rule">
            <el-checkbox label="1" name="1">周六不发</el-checkbox>
            <el-checkbox label="2" name="2">周日不发</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <div class="dialog-tips">
            1、平台审核通过后，店铺正常接单，待发货的订单【要求发货日】将按此调整，已发货订单【要求发货日】不受影响。
          </div>
          <div class="dialog-tips m-b-20">
            2、若都不选则视为周六日正常发货。
          </div>
        </el-form-item>
        <el-form-item>
          <el-button @click="visible = false">取消</el-button>
          <el-button type="primary" @click="submitForm('addForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRuleLists,
  postRules,
  getCurrentDetail
} from "@/models/orderReportModel";
import moment from "moment";
export default {
  data() {
    return {
      detail: {
        start_time: "", //接单时间
        end_time: "", //截单时间
        week_end_rule_str: ""
      },
      queryInfo: {
        page: 1,
        page_size: 10,
        current: 1, // 当前页
        total: 0 //总数
      }, // 分页配置数据
      addForm: {
        week_rule: [],
        start_time: "",
        end_time: ""
      },
      tableData: [], // 表格数据
      loading: true,
      visible: false, //休店弹框
      rules: {
        start_time: [
          {
            type: "date",
            required: true,
            message: "请选择接单时间",
            trigger: "change"
          }
        ],
        end_time: [
          {
            type: "date",
            required: true,
            message: "请选择截单时间",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {
    this.getDetail();
    this.getList({ page: 1, page_size: 10 }); //获取列表
  },
  methods: {
    //获取数据列表
    getList(param) {
      const params = {
        page: param.page || this.queryInfo.page || 1,
        page_size: param.page_size || this.queryInfo.page_size || 10
      };
      getRuleLists(params)
        .then(res => {
          this.loading = false;
          this.tableData = res.list || []; // 获取数据
          this.queryInfo.total = res.total;
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err.message);
        });
    },
    // 当前店铺信息
    getDetail() {
      getCurrentDetail()
        .then(res => {
          if (res) {
            this.detail = res;
            let ruleArr = [];
            switch (res.week_end_rule) {
              case 1:
                ruleArr = ["1", "2"];
                break;
              case 3:
                ruleArr = ["2"];
                break;
              case 4:
                ruleArr = ["1"];
                break;
              default:
                break;
            }
            this.addForm = {
              week_rule: ruleArr,
              start_time: res.start_time
                ? new Date(
                    2023,
                    11,
                    30,
                    res.start_time.substr(0, 2),
                    res.start_time.substr(3, 5)
                  )
                : "",
              end_time: res.end_time
                ? new Date(
                    2023,
                    11,
                    30,
                    res.end_time.substr(0, 2),
                    res.end_time.substr(3, 5)
                  )
                : ""
            };
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },

    // 改变pagesize
    handleSizeChange(value) {
      this.queryInfo.page_size = value;
      this.searchForm.page_size = value;
      const params = { page: this.queryInfo.page, page_size: value };
      this.getList(params);
    },
    // 改变page
    handleCurrentChange(value) {
      this.queryInfo.page = value;
      this.searchForm.page = value;
      const params = { page: value, page_size: this.queryInfo.page_size };
      this.getList(params);
    },
    // 编辑发货规则
    showDialog() {
      this.visible = true;
    },
    // 关闭休店弹框
    hideDialog() {
      this.visible = false;
      this.$refs["addForm"].resetFields();
    },
    submitForm(formName) {
      // console.log("this.", this);
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.onConfirm();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onConfirm() {
      this.$confirm("确定要保存更改内容吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false
      })
        .then(() => {
          this.onSubmit();
        })
        .catch(() => {});
    },
    onSubmit() {
      const { week_rule, end_time, start_time } = this.addForm;
      let weekend_rule = 2;
      if (week_rule.length == 0) {
        weekend_rule = 2;
      } else if (week_rule.length == 2) {
        weekend_rule = 1;
      } else if (week_rule.length == 1 && week_rule[0] == "1") {
        weekend_rule = 4;
      } else if (week_rule.length == 1 && week_rule[0] == "2") {
        weekend_rule = 3;
      }
      const params = {
        weekend_rule,
        start_order_time: moment(start_time).format("HH:mm"),
        stop_order_time: moment(end_time).format("HH:mm")
      };
      postRules(params)
        .then(res => {
          this.visible = false;
          this.$message.success("提交成功！");

          this.getDetail();
          this.getList({ page: 1, page_size: 10 }); //获取导出数据的列表
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    }
  }
};
</script>
<style lang="scss">
.ship-rules-wrap {
  .page-header {
    margin: 8px 0 30px;
    font-size: 14px;
    .title-left {
      font-size: 16px;
      font-weight: bold;
      display: flex;
    }
    .m-l-40 {
      margin-left: 40px;
    }
    .title-top {
      border-bottom: 1px solid #eee;
      padding-bottom: 8px;
    }
  }
  .gray-bg {
    position: absolute;
    width: 100%;
    height: 14px;
    left: 0;
    background: #eee;
    top: 110px;
  }
  .apply-btn {
    border: 1px solid #ff6224;
    padding: 3px 12px;
    font-size: 13px;
    border-radius: 4px;
    color: #ff6224;
    margin-left: 24px;
    cursor: pointer;
  }
  .m-b-8 {
    margin-bottom: 8px;
  }
  .c-red {
    color: #ff4d4f;
  }
  .status-tag {
    border: 1px solid #6ee6b2;
    background-color: #e6fff2;
    color: #00be7e;
    padding: 2px 8px;
    margin-right: 40px;
    font-size: 12px;
    font-weight: normal;
    &.close {
      border: 1px solid rgba(0, 0, 0, 0.15);
      background-color: rgba(0, 0, 0, 0.04);
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .top-info {
    text-align: center;
    margin: 14px auto;
    line-height: 45px;
  }
  .text-left {
    text-align: left;
  }
}
.rule-edit-form .el-form-item {
  margin-bottom: 10px;

  .c-red {
    color: #ff4d4f;
  }
}
.ship-rule-dialog {
  .el-form-item__label {
    text-align: right !important;
  }
  .dialog-tips {
    line-height: 22px;
    font-size: 13px;
  }
  .m-b-20 {
    margin-bottom: 20px;
  }
}
/deep/.el-table tr {
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderReport/shipRules.vue